// @core/api/endpoints/chat/pin_message.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PinMessageRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Pin a message
 * Pins a message to the conversation for easy access. Pinned messages appear in a dedicated list and remain visible regardless of scroll position.
 */
export async function PinMessage(
  conversation_id: string,
  message_id: string,
  data: PinMessageRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/messages/:message_id/pin`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':message_id', encodeURIComponent(message_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
